import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M6.765 21H3.5c-.828 0-1.5-.616-1.5-1.375v-8.25C2 10.615 2.672 10 3.5 10h3.407c1.822-.334 3.439-2.09 3.439-3.725V1.638l.97-.029c.052-.002.094-.002.166-.002 2.036 0 2.955.934 2.955 3.591V8.67h5.91c.622 0 1.187.223 1.556.675.353.43.457.986.341 1.554l-1.786 8.73C20.19 20.939 18.838 22 17.475 22H9a2.993 2.993 0 0 1-2.236-1zm14.5-10.302c.06-.29.012-.54-.136-.72-.162-.199-.44-.308-.782-.308h-6.91V5.198c0-2.41-.774-2.59-1.955-2.59h-.136v3.667c0 2.193-2.061 4.35-4.345 4.724V19a2 2 0 0 0 2 2h8.474c.895 0 1.832-.735 2.004-1.572l1.786-8.73zM3.5 11c-.276 0-.5.201-.5.45v8.1c0 .249.224.45.5.45h2a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-2z"
});

var SvgThumbsUp = function SvgThumbsUp(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgThumbsUp;